// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"style_headerContainer__3-zSX","bold":"style_bold__3O0qG"};